<template>
  <div class="kgwl-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="物料类型">
              <el-select v-model="searchForm.classify" style="width: 120px" filterable clearable
                @keyup.enter.native="Search">
                <el-option v-for="item in classifyOptions" :key="item" :label="item" :value="item" />
              </el-select>
            </el-form-item>
            <el-form-item label="客服">
              <el-select v-model="searchForm.serverId" style="width: 120px" filterable clearable
                @keyup.enter.native="Search">
                <el-option v-for="item in serviceOptions" :key="item.serverId" :label="item.username"
                  :value="item.serverId" />
              </el-select>
            </el-form-item>
            <el-form-item label="借用归还">
              <el-select v-model="searchForm.br" style="width: 110px" clearable @keyup.enter.native="Search">
                <el-option label="是" value="1" />
                <el-option label="否" value="0" />
              </el-select>
            </el-form-item>
            <el-form-item label="归还方式">
              <el-select v-model="searchForm.rt" style="width: 120px" filterable clearable allow-create default-first-option
                @keyup.enter.native="Search">
                <el-option v-for="item in returnTypeOptions" :key="item" :label="item" :value="item" />
              </el-select>
            </el-form-item>
            <el-form-item label="转交/归还">
              <el-select v-model="searchForm.ir" style="width: 110px" clearable @keyup.enter.native="Search">
                <el-option label="是" value="1" />
                <el-option label="否" value="0" />
              </el-select>
            </el-form-item>
            <el-form-item label="车间接收">
              <el-select v-model="searchForm.is" style="width: 110px" clearable @keyup.enter.native="Search">
                <el-option label="是" value="1" />
                <el-option label="否" value="0" />
              </el-select>
            </el-form-item>
            <el-form-item label="订单分配">
              <el-select v-model="searchForm.ifp" style="width: 110px" clearable @keyup.enter.native="Search">
                <el-option label="是" value="1" />
                <el-option label="否" value="0" />
              </el-select>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search" />
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-plus" @click="openAddDialog">新增客供物料</el-button>
              <el-button icon="el-icon-document" size="small" @click="exportExcel">导出Excel</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-row>
              <el-col :span="24" v-loading="loading">
                <el-table :data="tableData" stripe style="width: 100%">
                  <el-table-column label="订单号" width="120" align="center" fixed show-overflow-tooltip prop="ordernum">
                    <template slot-scope="scope">
                      <span style="cursor: pointer; color: #409EFF;" @click="toOrderDetail(scope.row)">
                        {{ scope.row.ordernum }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column label="慕鹿2.0订单号" width="120" align="center" fixed show-overflow-tooltip prop="orderId20">
                    <template slot-scope="scope">
                      <span style="cursor: pointer; color: #409EFF;">
                        {{ scope.row.orderId20 }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column label="生产单号" width="110" align="center" fixed show-overflow-tooltip prop="produnum">
                    <template slot-scope="scope">
                      <span style="cursor: pointer; font-weight: 500; color:#409EFF;" v-if="scope.row.produnum"
                        @click="toOrderDetail(scope.row)">
                        {{ scope.row.produnum }}
                      </span>
                      <span style="font-weight: 500; color:#999999;" v-else>N/A</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="订单状态"
                    width="100"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <el-tag disable-transitions size="mini" v-if="scope.row.mark===1" type="warning">未提交</el-tag>
                      <el-tag disable-transitions size="mini" v-if="scope.row.mark===2" type="warning">待接单</el-tag>
                      <el-tag disable-transitions size="mini" v-if="scope.row.mark===3" class="tcf-tag-1">售后处理</el-tag>
                      <el-tag disable-transitions size="mini" v-if="scope.row.mark===4" class="tcf-tag-5">技术评估</el-tag>
                      <el-tag disable-transitions size="mini" v-if="scope.row.mark===5" class="tcf-tag-4">拆单分配</el-tag>
                      <el-tag disable-transitions size="mini" v-if="scope.row.mark===6" class="tcf-tag-2">待拆单</el-tag>
                      <el-tag disable-transitions size="mini" v-if="scope.row.mark===7" class="tcf-tag-6">订单确认</el-tag>
                      <el-tag disable-transitions size="mini" v-if="scope.row.mark===8" class="tcf-tag-3">待报价</el-tag>
                      <el-tag disable-transitions size="mini" v-if="scope.row.mark===9" class="tcf-tag-9">预付款</el-tag>
                      <el-tag disable-transitions size="mini" v-if="scope.row.mark===10" class="tcf-tag-7">工厂分派</el-tag>
                      <el-tag disable-transitions size="mini" v-if="scope.row.mark===11" class="tcf-tag-8">工厂接单</el-tag>
                      <el-tag disable-transitions size="mini" v-if="scope.row.mark===12" class="tcf-tag-10">订单排产</el-tag>
                      <el-tag disable-transitions size="mini" v-if="scope.row.mark===13" class="tcf-tag-11">订单生产</el-tag>
                      <el-tag disable-transitions size="mini" v-if="scope.row.mark===88" class="tcf-tag-1">待审单</el-tag>
                      <el-tag disable-transitions size="mini" v-if="scope.row.mark===99">已取消</el-tag>
                      <el-tag disable-transitions size="mini" v-if="scope.row.mark===100">已完成</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column label="经销商" width="130" align="center" show-overflow-tooltip prop="dealerName">
                  </el-table-column>
                  <el-table-column label="终端地址" min-width="170" show-overflow-tooltip prop="address">
                  </el-table-column>
                  <el-table-column label="客服" width="80" align="center" show-overflow-tooltip prop="servername">
                  </el-table-column>
                  <el-table-column label="物料名称" width="120" align="center" show-overflow-tooltip prop="cmname">
                  </el-table-column>
                  <el-table-column label="物料分类" width="100" align="center" show-overflow-tooltip prop="classify">
                    <template slot-scope="scope">
                      <el-tag v-if="scope.row.classify" type="primary" size="mini">{{ scope.row.classify }}</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column label="物料说明" min-width="150" show-overflow-tooltip prop="explain">
                  </el-table-column>
                  <el-table-column label="物料图片" width="140">
                    <template slot-scope="scope">
                      <template v-if="scope.row.imgs">
                        <el-image v-for="(img, idx) in scope.row.imgs.split(',')" :key="idx" :src="img"
                          style="width: 24px; height: 24px; margin-right: 2px; cursor: pointer;" fit="cover"
                          :preview-src-list="scope.row.imgs.split(',')" @click.stop />
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column label="客服备注" min-width="150" show-overflow-tooltip prop="info">
                  </el-table-column>
                  <el-table-column label="暂存位置" width="120" align="center" show-overflow-tooltip prop="storage">
                  </el-table-column>
                  <el-table-column label="工厂分派时间" width="150" align="center" show-overflow-tooltip prop="sendTime">
                  </el-table-column>
                  <el-table-column label="工厂接单时间" width="150" align="center" show-overflow-tooltip prop="factoryTime">
                  </el-table-column>
                  <el-table-column label="借用/转交人" width="100" align="center" show-overflow-tooltip prop="bname">
                  </el-table-column>
                  <el-table-column label="借用归还" width="80" align="center">
                    <template slot-scope="scope">
                      <el-tag v-if="scope.row.br === 1" type="success" size="mini">是</el-tag>
                      <el-tag v-else type="warning" size="mini">否</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column label="退还类型" width="110" align="center">
                    <template slot-scope="scope">
                      <el-tag v-if="scope.row.cmtype === 0" type="info" size="mini">无需退换</el-tag>
                      <el-tag v-else-if="scope.row.cmtype === 1" type="warning" size="mini">需要退货</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column label="归还方式" width="100" align="center" show-overflow-tooltip prop="rt">
                  </el-table-column>
                  <el-table-column label="转交/归还" width="80" align="center">
                    <template slot-scope="scope">
                      <el-tag v-if="scope.row.ir === 1" type="success" size="mini">是</el-tag>
                      <el-tag v-else type="warning" size="mini">否</el-tag> </template>
                  </el-table-column>
                  <el-table-column label="备注" min-width="150" show-overflow-tooltip prop="remark">
                  </el-table-column>
                  <el-table-column label="操作" width="140" align="center" fixed="right">
                    <template slot-scope="scope">
                      <el-tooltip content="详情" placement="top" :open-delay="300">
                        <el-button type="text" size="mini" icon="el-icon-view" @click="openDetailDialog(scope.row)" />
                      </el-tooltip>
                      <el-tooltip content="编辑" placement="top" :open-delay="300">
                        <el-button type="text" size="mini" icon="el-icon-edit" @click="openEditDialog(scope.row)" />
                      </el-tooltip>
                      <el-tooltip content="处理物料" placement="top" :open-delay="300">
                        <el-button type="text" size="mini" icon="el-icon-s-order"
                          @click="openHandleDialog(scope.row)" />
                      </el-tooltip>
                      <el-tooltip content="删除" placement="top" :open-delay="300">
                        <el-button type="text" size="mini" icon="el-icon-delete" style="color: #f56c6c;"
                          @click="handleDelete(scope.row)" />
                      </el-tooltip>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination v-if="total > 0" style="margin-top: 20px;" background @size-change="handleSizeChange"
                  @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[20, 50, 100]"
                  :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>

        </div>
      </el-col>
    </el-row>

    <!-- 新增/编辑客供物料弹窗 -->
    <el-dialog :title="editForm.id ? '编辑客供物料' : '新增客供物料'" :visible.sync="editFormVisible" width="600px" top="10vh"
      :close-on-click-modal="false" :destroy-on-close="true" :lock-scroll="true" :append-to-body="true">
      <el-form :model="editForm" :rules="editRules" ref="editFormRef" label-width="80px" size="small">
        <el-form-item label="订单" prop="orderId">
          <OrderChoose v-model="editForm.orderId" :oldorderid="editForm.orderId" :disabled="!!editForm.id"
            style="width: 100%;" />
        </el-form-item>
        <el-form-item label="慕鹿2.0订单号" prop="orderId20">
          <el-input v-model="editForm.orderId20" placeholder="请输入慕鹿2.0订单号" />
        </el-form-item>
        <el-form-item label="物料名称" prop="name">
          <el-input v-model="editForm.name" placeholder="请输入物料名称" />
        </el-form-item>
        <el-form-item label="物料分类" prop="classify">
          <el-select v-model="editForm.classify" filterable allow-create default-first-option placeholder="请选择物料分类"
            style="width: 100%;">
            <el-option v-for="item in classifyOptions" :key="item" :label="item" :value="item" />
          </el-select>
        </el-form-item>
        <el-form-item label="物料说明" prop="explain">
          <el-input v-model="editForm.explain" type="textarea" :rows="2" placeholder="请输入物料说明" />
        </el-form-item>
        <el-form-item label="退还类型" prop="type">
          <el-radio-group v-model="editForm.type">
            <el-radio :label="0">无需退换</el-radio>
            <el-radio :label="1">需要退货</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="editForm.remark" type="textarea" :rows="2" placeholder="请输入备注" />
        </el-form-item>
        <el-form-item label="图片" prop="imgs">
          <MultiImg v-model="editForm.imgIds" :old="imgList" :limit="9" size="sm" @change="handleImgChange" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="editFormVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="btnLoading" @click="handleSave">{{ editForm.id ? '保存' : '新增'
          }}</el-button>
      </div>
    </el-dialog>

    <!-- 处理物料情况弹窗 -->
    <el-dialog title="处理物料情况" :visible.sync="handleDialogVisible" width="700px" top="10vh" :close-on-click-modal="false"
      :destroy-on-close="true" :lock-scroll="true" :append-to-body="true">
      <!-- 基础信息表格 -->
      <table class="detail-table" style="margin-bottom: 15px;">
        <tr>
          <td class="label" style="width: 90px;">物料名称</td>
          <td>{{ handleForm.cmname || '--' }}</td>
          <td class="label" style="width: 90px;">物料分类</td>
          <td>
            <el-tag v-if="handleForm.classify" type="primary" size="mini">{{ handleForm.classify }}</el-tag>
            <span v-else>--</span>
          </td>
          <td class="label" style="width: 90px;">退还类型</td>
          <td>
            <el-tag v-if="handleForm.cmtype === 0" type="info" size="mini">无需退换</el-tag>
            <el-tag v-else-if="handleForm.cmtype === 1" type="warning" size="mini">需要退货</el-tag>
            <span v-else>--</span>
          </td>
        </tr>
      </table>
      <el-divider style="margin: 10px 0;" />
      <el-form :model="handleForm" :rules="handleRules" ref="handleFormRef" label-width="100px" size="small">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="借用人" prop="bname">
              <el-input v-model="handleForm.bname" placeholder="请输入借用人" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="借用是否归还" prop="br">
              <el-radio-group v-model="handleForm.br">
                <el-radio :label="0">否</el-radio>
                <el-radio :label="1">是</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="暂存位置" prop="storage">
              <el-select v-model="handleForm.storage" filterable allow-create default-first-option
                placeholder="请选择或输入暂存位置" style="width: 100%;">
                <el-option v-for="item in storageOptions" :key="item" :label="item" :value="item" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否转交/归还" prop="ir">
              <el-radio-group v-model="handleForm.ir">
                <el-radio :label="0">否</el-radio>
                <el-radio :label="1">是</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12" v-if="handleForm.cmtype === 1">
            <el-form-item label="归还方式" prop="rt">
              <el-select v-model="handleForm.rt" clearable filterable allow-create default-first-option
                placeholder="请选择或输入归还方式" style="width: 100%;">
                <el-option v-for="item in returnTypeOptions" :key="item" :label="item" :value="item" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="客服备注" prop="info">
              <el-input v-model="handleForm.info" type="textarea" :rows="3" placeholder="请输入客服备注" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider content-position="left">发货信息</el-divider>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="发货物流" prop="transpName">
              <el-input v-model="handleForm.transpName" placeholder="请输入发货物流" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发货单号" prop="transpnum">
              <el-input v-model="handleForm.transpnum" placeholder="请输入发货单号" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发货时间" prop="hairTime">
              <el-date-picker v-model="handleForm.hairTime" type="datetime" placeholder="选择发货时间"
                value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%;" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车间接收时间" prop="workshopTime">
              <el-date-picker v-model="handleForm.workshopTime" type="datetime" placeholder="选择车间接收时间"
                value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%;" />
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 退货信息：仅需要退货时显示 -->
        <template v-if="handleForm.cmtype === 1">
          <el-divider content-position="left">退货信息</el-divider>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="退货物流" prop="returnTranspname">
                <el-input v-model="handleForm.returnTranspname" placeholder="请输入退货物流名称" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="退货单号" prop="returnTranspnum">
                <el-input v-model="handleForm.returnTranspnum" placeholder="请输入退货物流单号" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="车间退货时间" prop="returnWorkshopTime">
                <el-date-picker v-model="handleForm.returnWorkshopTime" type="datetime" placeholder="选择车间退货时间"
                  value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%;" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="客户接收时间" prop="returnHairTime">
                <el-date-picker v-model="handleForm.returnHairTime" type="datetime" placeholder="选择客户接收时间"
                  value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%;" />
              </el-form-item>
            </el-col>
          </el-row>
        </template>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="handleDialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="btnLoading" @click="handleSaveMaterial">保存</el-button>
      </div>
    </el-dialog>

    <!-- 客供物料详情弹窗 -->
    <el-dialog title="客供物料详情" :visible.sync="detailDialogVisible" width="750px" top="5vh">
      <table class="detail-table">
        <tr>
          <td class="label">订单号</td>
          <td>
            <span style="cursor: pointer; color: #409EFF;" @click="toOrderDetail(detailData)">
              {{ detailData.ordernum }}
            </span>
          </td>
          <td class="label">生产单号</td>
          <td>
            <span style="cursor: pointer; font-weight: 500; color:#409EFF;" v-if="detailData.produnum"
              @click="toOrderDetail(detailData)">
              {{ detailData.produnum }}
            </span>
            <span style="font-weight: 500; color:#999999;" v-else>N/A</span>
          </td>
        </tr>
        <tr>
          <td class="label">经销商</td>
          <td>{{ detailData.dealerName || '--' }}</td>
          <td class="label">客服</td>
          <td>{{ detailData.servername || '--' }}</td>
        </tr>
        <tr>
          <td class="label">终端地址</td>
          <td colspan="3">{{ detailData.address || '--' }}</td>
        </tr>
        <tr>
          <td class="label">物料名称</td>
          <td>{{ detailData.cmname || '--' }}</td>
          <td class="label">物料分类</td>
          <td>
            <el-tag v-if="detailData.classify" type="primary" size="mini">{{ detailData.classify }}</el-tag>
            <span v-else>--</span>
          </td>
        </tr>
        <tr>
          <td class="label">物料说明</td>
          <td colspan="3">{{ detailData.explain || '--' }}</td>
        </tr>
        <tr>
          <td class="label">物料图片</td>
          <td colspan="3">
            <div v-if="detailImgList && detailImgList.length > 0" class="detail-images">
              <el-image v-for="(img, index) in detailImgList" :key="index" :src="img" :preview-src-list="detailImgList"
                fit="cover" style="width: 80px; height: 80px; margin-right: 8px; cursor: pointer;" />
            </div>
            <span v-else>--</span>
          </td>
        </tr>
        <tr>
          <td class="label">客服备注</td>
          <td colspan="3">{{ detailData.info || '--' }}</td>
        </tr>
        <tr>
          <td class="label">工厂分派时间</td>
          <td>{{ detailData.sendTime || '--' }}</td>
          <td class="label">工厂接单时间</td>
          <td>{{ detailData.factoryTime || '--' }}</td>
        </tr>
        <tr>
          <td class="label">借用/转交人</td>
          <td>{{ detailData.bname || '--' }}</td>
          <td class="label">借用归还</td>
          <td>
            <el-tag v-if="detailData.br === 1" type="success" size="mini">是</el-tag>
            <el-tag v-else type="warning" size="mini">否</el-tag>
          </td>
        </tr>
        <tr>
          <td class="label">暂存位置</td>
          <td>{{ detailData.storage || '--' }}</td>
          <td class="label">退还类型</td>
          <td>
            <el-tag v-if="detailData.cmtype === 0" type="info" size="mini">无需退换</el-tag>
            <el-tag v-else-if="detailData.cmtype === 1" type="warning" size="mini">需要退货</el-tag>
          </td>
        </tr>
        <tr>
          <td class="label">归还方式</td>
          <td>{{ detailData.rt || '--' }}</td>
          <td class="label">转交/归还</td>
          <td>
            <el-tag v-if="detailData.ir === 1" type="success" size="mini">是</el-tag>
            <el-tag v-else type="warning" size="mini">否</el-tag>
          </td>
        </tr>
        <tr>
          <td class="label">备注</td>
          <td colspan="3">{{ detailData.remark || '--' }}</td>
        </tr>
        <tr>
          <td class="label">发货时间</td>
          <td>{{ detailData.hairTime || '--' }}</td>
          <td class="label">发货物流</td>
          <td>{{ detailData.transpName || '--' }} {{ detailData.transpnum || '' }}</td>
        </tr>
        <tr>
          <td class="label">车间接收时间</td>
          <td>{{ detailData.workshopTime || '--' }}</td>
          <td class="label">客户接收时间</td>
          <td>{{ detailData.returnHairTime || '--' }}</td>
        </tr>
        <tr>
          <td class="label">车间退货时间</td>
          <td>{{ detailData.returnWorkshopTime || '--' }}</td>
          <td class="label">退货物流</td>
          <td>{{ detailData.returnTranspname || '--' }} {{ detailData.returnTranspnum || '' }}</td>
        </tr>
      </table>
      <div slot="footer">
        <el-button size="small" @click="detailDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { exportClientMaterials, getClientMaterials, addorEditClientMaterial, delClientMaterial, getClientMaterialData, getServers, dealClientMaterial, getStorages, getReturnType } from '@/api/erp'
import OrderChoose from '@/components/OrderChoose'
import MultiImg from '@/components/upload/MultiImg'

export default {
  name: 'kgwl',
  components: {
    OrderChoose,
    MultiImg
  },
  data() {
    return {
      btnLoading: false,
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      searchForm: {
        search: '',
        classify: '',
        serverId: '',
        dealerId: '',
        br: '',
        rt: '',
        ir: '',
        is: '',
        ifp: '',
      },
      serviceOptions: [],
      storageOptions: [],
      returnTypeOptions: [],
      editFormVisible: false,
      detailDialogVisible: false,
      handleDialogVisible: false,
      detailData: {},
      detailImgList: [],
      imgList: [],
      classifyOptions: [],
      editForm: {
        id: null,
        orderId: '',
        name: '',
        classify: '',
        explain: '',
        type: 0,
        info: '',
        remark: '',
        imgs: '',
        imgIds: []
      },
      editRules: {
        name: [{ required: true, message: '请输入物料名称', trigger: 'blur' }],
        classify: [{ required: true, message: '请选择物料分类', trigger: 'change' }],
        type: [{ required: true, message: '请选择退换类型', trigger: 'change' }],
      },
      handleForm: {
        id: null,
        bname: '',
        br: 0,
        rt: '',
        ir: 0,
        cmtype: 0,
        storage: '',
        hairTime: '',
        transpName: '',
        transpnum: '',
        workshopTime: '',
        returnWorkshopTime: '',
        returnTranspname: '',
        returnTranspnum: '',
        returnHairTime: '',
        info: ''
      },
      handleRules: {},
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.getData()
    this.getClassifyOptions()
    this.getServiceOptions()
    this.getStorageOptions()
    this.getReturnTypeOptions()
  },
  methods: {
    getData() {
      const data = {
        search: this.searchForm.search,
        page: this.currentPage,
        limit: this.pageSize,
        userid: this.user.dUserid,
        groupid: this.user.dGroupid,
        classify: this.searchForm.classify || null,
        serverId: this.searchForm.serverId || null,
        br: this.searchForm.br || null,
        rt: this.searchForm.rt || null,
        ir: this.searchForm.ir || null,
        is: this.searchForm.is || null,
        ifp: this.searchForm.ifp || null,
      }
      this.loading = true
      getClientMaterials(data).then(response => {
        this.tableData = response.data || []
        this.total = response.total || 0
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    exportExcel() {
      const data = {
        search: this.searchForm.search,
        page: this.currentPage,
        limit: this.pageSize,
        userid: this.user.dUserid,
        groupid: this.user.dGroupid,
        classify: this.searchForm.classify || null,
        serverId: this.searchForm.serverId || null,
        br: this.searchForm.br || null,
        rt: this.searchForm.rt || null,
        ir: this.searchForm.ir || null,
        is: this.searchForm.is || null,
        ifp: this.searchForm.ifp || null,
      }
      this.$message({
        message: '数据正在导出，请稍候...',
        type: 'success'
      })
      exportClientMaterials(data).then(response => {
        const _this = this
        const xhr = new XMLHttpRequest()
        xhr.open('GET', response.data.dPath, true)
        xhr.responseType = 'blob'
        xhr.onload = function() {
          if (this.status === 200) {
            const blob = this.response
            const a = document.createElement('a')
            a.download = response.data.dName + '.' + response.data.dType
            a.href = window.URL.createObjectURL(blob)
            a.target = '_blank'
            a.click()
            const h = _this.$createElement
            _this.$msgbox({
              title: '下载提示',
              message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
                h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                h('a',
                  { attrs: {
                    href: window.URL.createObjectURL(blob),
                    target: '_blank',
                    download: `${response.data.dName}.${response.data.dType}`,
                    style: 'color: #409EFF;text-decoration:underline;'
                  }}, `点击这里`),
                h('span', null, `重新下载。`)
              ]),
              showCancelButton: false,
              confirmButtonText: '关闭',
              beforeClose: (action, instance, done) => {
                done()
              }
            }).then(action => {
            })
          }
        }
        xhr.send()
      })
    },
    Search() {
      this.currentPage = 1
      this.getData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    openAddDialog() {
      this.editForm = {
        id: null,
        orderId: '',
        orderId20: '',
        cmname: '',
        classify: '',
        explain: '',
        storage: '',
        cmtype: 0,
        info: '',
        remark: '',
        imgs: '',
        imgIds: []
      }
      this.imgList = []
      this.editFormVisible = true
    },
    openEditDialog(row) {
      // 处理图片数据：字符串转对象数组
      let imgId = 1
      if (row.imgs) {
        this.imgList = row.imgs.split(',').map(url => ({
          id: imgId++,
          url: url
        }));
      } else {
        this.imgList = []
      }
      this.editForm = {
        id: row.cmId,
        orderId: row.orderId,
        orderId20: row.orderId20,
        name: row.cmname,
        classify: row.classify,
        explain: row.explain,
        storage: row.storage,
        type: row.cmtype,
        info: row.info,
        remark: row.remark,
        imgs: row.imgs || '',
        imgIds: this.imgList.map(item => item.id)
      }
      this.editFormVisible = true
    },
    openDetailDialog(row) {
      this.detailData = { ...row }
      // 处理图片数据：字符串转数组
      this.detailImgList = row.imgs ? row.imgs.split(',') : []
      this.detailDialogVisible = true
    },
    handleSave() {
      this.$refs.editFormRef.validate(valid => {
        if (valid) {
          this.btnLoading = true
          // 将图片列表转成逗号分隔的字符串
          const submitForm = {
            ...this.editForm,
            imgs: this.imgList.map(item => item.url).join(','),
            imgIds: null
          }
          addorEditClientMaterial(submitForm).then(() => {
            this.$message.success(this.editForm.id ? '保存成功' : '新增成功')
            this.editFormVisible = false
            this.Search()
            this.getClassifyOptions()
            this.btnLoading = false
          }).catch(() => {
            this.btnLoading = false
          })
        }
      })
    },
    getClassifyOptions() {
      getClientMaterialData({}).then(response => {
        this.classifyOptions = response.data || []
      })
    },
    getServiceOptions() {
      getServers({}).then(response => {
        this.serviceOptions = response.data || []
      })
    },
    getStorageOptions() {
      getStorages({}).then(response => {
        this.storageOptions = response.data || []
      })
    },
    getReturnTypeOptions() {
      getReturnType({}).then(response => {
        this.returnTypeOptions = response.data || []
      })
    },
    handleDelete(row) {
      this.$confirm(`确定要删除客供物料 -《${row.cmname}》吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delClientMaterial({ id: row.id || row.cmId }).then(() => {
          this.$message.success('删除成功')
          this.getData()
        })
      }).catch(() => { })
    },
    handleImgChange(val) {
      this.imgList = val || []
    },
    openHandleDialog(row) {
      this.handleForm = {
        id: row.cmId,
        cmname: row.cmname || '',
        classify: row.classify || '',
        cmexplain: row.explain || '',
        cmtype: row.cmtype || 0,
        bname: row.bname || '',
        br: row.br || 0,
        rt: row.rt || '',
        ir: row.ir || 0,
        storage: row.storage || '',
        hairTime: row.hairTime || '',
        transpName: row.transpName || '',
        transpnum: row.transpnum || '',
        workshopTime: row.workshopTime || '',
        returnWorkshopTime: row.returnWorkshopTime || '',
        returnTranspname: row.returnTranspname || '',
        returnTranspnum: row.returnTranspnum || '',
        returnHairTime: row.returnHairTime || '',
        info: row.info || ''
      }
      this.handleDialogVisible = true
    },
    handleSaveMaterial() {
      this.$refs.handleFormRef.validate(valid => {
        if (valid) {
          this.btnLoading = true
          dealClientMaterial(this.handleForm).then(() => {
            this.$message.success('处理成功')
            this.handleDialogVisible = false
            this.Search()
            this.getStorageOptions()
            this.getReturnTypeOptions()
            this.btnLoading = false
          }).catch(() => {
            this.btnLoading = false
          })
        }
      })
    },
    toOrderDetail(row) {
      this.$router.push({
        path: '/work/order/' + row.orderId
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.detail-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ebeef5;
  font-size: 14px;

  td {
    padding: 8px 12px;
    border: 1px solid #ebeef5;

    &.label {
      width: 110px;
      background: #f5f7fa;
      color: #606266;
      font-weight: 500;
      text-align: right;
    }
  }
}
</style>
